import regular from "@fortawesome/fontawesome-free/scss/regular.scss";
import solid from "@fortawesome/fontawesome-free/scss/solid.scss";
import brands from "@fortawesome/fontawesome-free/scss/brands.scss";
import fontawesome from "@fortawesome/fontawesome-free";

fontawesome.library.add(solid, regular, brands)
const WebFont = require('webfontloader');

WebFont.load({
    google: {
        families: ['Roboto:300,400,500,700']
    },
    custom: {
        families: ['Font Awesome\ 5 Icons:400,900', 'Font Awesome\ 5 Brands:400'],
        urls: ['//use.fontawesome.com/releases/v5.9.0/css/all.css']
    }
});